const APIS = {
  DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  LOGIN_HISTORY: "/usermanagementservice/api/login-history/overview/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  GRID_REPORT_DATA_COURIER: "/projectsettingsservice/api/courier-grid-report/",
  GRID_REPORT_DATA_LOGISTIC:
    "/projectsettingsservice/api/logistic-grid-report/",
  STATUS: "/logisticservice/api/status/",
  CLIENT_SETTING: "/projectsettingsservice/api/configuration/",
  RUNSHEET_STATUS: "/runsheetservice/api/runsheet-settings/",
  RTV_STATUS: "/projectsettingsservice/api/rtv-order-settings/",
  MANIFEST_STATUS: "/manifestservice/api/manifest-settings/",
  DELIVERY_STATUS: "/logisticservice/api/delivery-settings/",
  PICKUPREQUEST_STATUS: "/pickuprequestservice/api/pickup-request-settings/",
  FISCAL_YEAR: "/usermanagementservice/api/fiscal-year/",
  BRANCH: "/usermanagementservice/api/branch/",
};

export default APIS;
